import { ID, WoosatTelecomResponse, Response } from '../../../../../_metronic/helpers'
import { Currency } from '../../../currency/currencies-list/core/_models'

export type Reseller = {
  id?: any
  user_id?: number
  uuid?: string
  reseller_name?: string
  contact_name?: string
  reseller_type?: string
  email_verified_at?: string
  account_password?: string
  personal_pin?: string
  remember_token?: string
  profile_image_url?: File | string | null
  email?: string
  phone?: string
  password?: any
  country_id?: any
  province_id?: any
  districts_id?: any
  is_reseller_verified?: number
  status?: number
  balance?: any
  payment?: any
  loan_balance?: any
  updated_at?: Date
  created_at?: Date
  profile_image?: File
  currency_preference_id?: any
  currency?: Currency
  parent_reseller_profile_image_url?: any
  parent_reseller_phone?: string
  parent_reseller_name?: string
  reseller_group_id?: number | null // Reseller group association
  can_create_sub_resellers?: boolean // Can the reseller create sub-resellers
  sub_reseller_limit?: number // Maximum number of sub-resellers allowed
  sub_resellers_can_create_sub_resellers?: boolean // Can sub-resellers create their own sub-resellers
}

export type ResellersQueryResponse = WoosatTelecomResponse<Reseller[]>

export const initialReseller: Reseller = {
  reseller_name: '',
  contact_name: '',
  profile_image_url: "",
  currency_preference_id: '',
  email: '',
  phone: '',
  balance: 0,
  country_id: '',
  province_id: '',
  districts_id: '',
  password: "",
  reseller_group_id: 1, // Default is null for no group assigned
  can_create_sub_resellers: false, // Default is false
  sub_reseller_limit: 0, // Default is 0
  sub_resellers_can_create_sub_resellers: false // Default is false
}
